// Authors pick the expiration at midnight Central; formatting in any other
// zone would show the day before.
const OFFER_TIME_ZONE = "America/Chicago";

/**
 * `[expiration-date]` value: "November 1, 2026". Falls back to the raw value
 * when the CMS date does not parse, so copy never shows "Invalid Date".
 */
export function formatOfferDate(
	isoDate: string | undefined,
	locale = "en-US"
): string | undefined {
	if (!isoDate) return undefined;

	const date = new Date(isoDate);
	if (Number.isNaN(date.getTime())) return isoDate;

	return new Intl.DateTimeFormat(locale, {
		year: "numeric",
		month: "long",
		day: "numeric",
		timeZone: OFFER_TIME_ZONE
	}).format(date);
}
